import React, { useState, useEffect, useRef } from 'react';

const Why = () => {
  const imagePaths = [
    "/your-image4.webp",
    "/your-image6.webp"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const imageRef = useRef(null);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % imagePaths.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + imagePaths.length) % imagePaths.length);
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 50000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="flex flex-row mq450:flex-col w-full bg-black text-white">
      {/* Obrazek */}
      <div className="flex w-full mq450:order-2 relative overflow-hidden">
        <img
          ref={imageRef}
          src={imagePaths[currentIndex]}
          className="w-full h-full object-cover mq450:object-cover transition-all duration-500"
          alt={`Slajd ${currentIndex + 1}`}
        />
        <button
          onClick={prevImage}
          className="absolute cursor-pointer left-5 top-1/2 transform -translate-y-1/2 px-4 py-3 text-yellow-400 font-bold text-[32px] bg-black bg-opacity-60 transition duration-300 z-10 hover:bg-yellow-300 hover:text-black"
        >
          ❮
        </button>
        <button
          onClick={nextImage}
          className="absolute cursor-pointer right-5 top-1/2 transform -translate-y-1/2 px-4 py-3 text-yellow-400 font-bold text-[32px] bg-black bg-opacity-60 transition duration-300 z-10 hover:bg-yellow-300 hover:text-black"
        >
          ❯
        </button>
      </div>

      {/* Tekst */}
      <div className="flex w-full mq450:order-1 flex-col justify-center mq450:max-w-full gap-4 h-auto">
        <div className="p-10 mq450:px-[16px] mq450:py-[48px]">
          <h2 className="text-[48px] font-bold mb-6 mq1024:text-[24px]">DLACZEGO WARTO KUPIĆ?</h2>
          <p className="text-[18px] leading-[1.8] mq1024:text-[16px]">
            To proste, kupujesz produkt o wysokiej jakości, który jest produkowany w Polsce.
            Tkanina, nici i nadruki posiadają certyfikat <span className="font-bold">OEKO-TEX® STANDARD 100</span>, co oznacza,
            że nie zawierają żadnych szkodliwych substancji chemicznych oraz są wytwarzane
            w sposób etyczny i przyjazny dla środowiska. Kupując koszulkę, nie tylko wybierasz
            jakość i bezpieczeństwo, ale też wspierasz moją twórczość w internecie.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Why;
